import { render, staticRenderFns } from "./previewImg.vue?vue&type=template&id=3b09749a&scoped=true&"
import script from "./previewImg.vue?vue&type=script&lang=js&"
export * from "./previewImg.vue?vue&type=script&lang=js&"
import style0 from "./previewImg.vue?vue&type=style&index=0&id=3b09749a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b09749a",
  null
  
)

export default component.exports